var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"color":_vm.getRandomColor(),"size":_vm.avatarSize}},[_vm._t("default",null,{"text":"iconText"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }